import React from "react";
import { Box, Typography, Paper, Stack } from "@mui/material";
import { PolicyOrAccount } from "../../interfaces/DTO/mislaka_xml_models";
import { formatLiquidityMatchedDepositCap } from "../../utils/enumFormatter";
import { MimshakService } from "../../services/mimshakService";
import {
  formatCurrency,
  formatIsoDateToMMYYYY,
} from "../../utils/namesFormater";

interface LiquiditySummaryProps {
  policies: PolicyOrAccount[];
}

export const LiquiditySummary: React.FC<LiquiditySummaryProps> = ({
  policies,
}) => {
  // קיבוץ לפי matched_deposit_cap
  const groupedByMatchedDepositCap =
    MimshakService.groupAllLiquidityDetailsByMatchedDepositCap(policies);

  // Calculate total liquidity
  const totalLiquidity = Object.values(groupedByMatchedDepositCap).reduce(
    (acc, value) => acc + value,
    0
  );

  const liquiditySummaries = MimshakService.getAllLiquiditySummaries(policies);
  const alreadyLiquiedAmount =
    MimshakService.getPastLiquidityAmountSum(policies);
  const nonLiquiedSummaries =
    MimshakService.getFutureLiquiditySummaries(policies);

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom>
       האם יהיה תשלום מס רווחי הון על הסכום
        בפדיון ?  {formatCurrency(totalLiquidity)}
      </Typography>

      <Stack spacing={2} direction="row" flexWrap="wrap" justifyContent="start">
        {Object.entries(groupedByMatchedDepositCap).map(([key, total]) => (
          <Box key={key} sx={{ flex: "1 1 calc(33% - 16px)", mb: 2 }}>
            <Paper elevation={3} sx={{ p: 2, textAlign: "center" }}>
              <Typography variant="subtitle1">
                {formatLiquidityMatchedDepositCap(Number(key))}
              </Typography>
              <Typography variant="h6">{formatCurrency(total)}</Typography>
            </Paper>
          </Box>
        ))}
      </Stack>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          פירוט סכומים נזילים:
        </Typography>
        <Stack
          spacing={2}
          direction="row"
          flexWrap="wrap"
          justifyContent="start"
        >
          <Box sx={{ flex: "1 1 calc(100% - 16px)", mb: 2 }}>
            <Paper elevation={3} sx={{ p: 2, textAlign: "center" }}>
              <Typography variant="h6">
                נזיל: {formatCurrency(alreadyLiquiedAmount)}
              </Typography>
            </Paper>
          </Box>
          {nonLiquiedSummaries.map((summary, index) => (
            <Box key={index} sx={{ flex: "1 1 calc(33% - 16px)", mb: 2 }}>
              <Paper elevation={3} sx={{ p: 2, textAlign: "center" }}>
                <Typography variant="h6">
                  {formatCurrency(summary.liquidity_amount)}
                </Typography>
                <Typography variant="subtitle1">
                  {formatIsoDateToMMYYYY(summary.liquidity_date)}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
